import Vue from 'vue';
import axios from 'axios'
/*
    Frontcore Phrases VUE plugin

    Usage:
    Its globally accessible using this.$phrasePlugin.translate(key).

    Install:
    import PhrasePlugin from './plugins/PhrasePlugin';
    Vue.use(PhrasePlugin, {
        // This is the default phrase route url.
        baseUrl:  'https://myphrases.com',

         // this is the default dictionary before any phrases as been loaded from the server.
        dictionary: {},

        // When this is set to true, we will automatically fetch phrases from the server.
        init: true, // Load phrases when created

        // This is the initial language that we want to use.
        language: 'sv-SE'
    });

    Note!
     Consider using the following snippet inside a component to make it easier to use.
     methods: {  t : function(key){  return this.$phrasePlugin.translate(key); } }

*/


const PhrasePlugin = {
    install(vue, opts) {

        // console.log('Installing the Frontcore PhrasePlugin!');

        /* Default values. Override by passing in options to the plugin. */
        const options = {
            baseUrl: 'https://internal.api.frontcore.com',
            language: 'no',
            defaultLanguage: 'no',
            dictionary: {},
            init: true,
            ...opts
        };

        /*
        * This registers the phrases plugin directly with the vue instance so
        * that we can access it using 'this.$phrasePlugin' globally.
        * */
        vue.prototype.$phrasePlugin = new Vue({
            data: function(){
                return {
                    language_id: options.language,
                    default_language_id: options.defaultLanguage,
                    dictionary: options.dictionary
                }
            },
            methods: {
                /*
                * The translate function takes a key as argument and looks up the value in the dictionary.
                * If nothing is found, we default to the key.
                * */
                translate(key){
                    if(!this.dictionary[key])
                        return key;

                    return this.dictionary[key];
                },

                /*
                * Set the language we want the translations to be in....
                * When i.e. you select a different language in the view, make sure to
                * call this function with the language id.
                *
                * The language id is watched, so whenever this function is invoked,
                * the phrases are fetched from the server.
                *
                * */
                setLanguageId(language_id){
                    this.language_id = language_id;
                    this.$emit('language-change', language_id);
                },

                getLanguageId(){
                  return this.language_id;
                },

                /*
                * Load all the phrases for the given language
                * Usually you do not need to use this directly, its invoked on init and whenever
                * the language id changes.
                * */
                loadPhrases(){
                    let url = options.baseUrl + '/phrases/' + this.language_id + '?defaultLanguage='+this.default_language_id;
                    axios.get(url).then(function (response) {
                        this.dictionary = response.data.phrases;
                    }.bind(this));
                }
            },

            watch: {
                /* If the language_id changes, we want to automatically fetch the new dictionary. */
                language_id: function (current) {
                    if(current)
                        this.loadPhrases();
                }
            },
            /* Initial loading of phrases. */
            created: function(){
                if(options.init)
                    this.loadPhrases();
            }
        });
    }
};

export default PhrasePlugin;